import { ScheduleState } from "../../../type/schedule-state";

export const clearSelectedStatusDispatch = (state: ScheduleState) => {
  state.selectedStatus = [];
};
